import { render, staticRenderFns } from "./void.vue?vue&type=template&id=af726e12&"
import script from "./void.vue?vue&type=script&lang=js&"
export * from "./void.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports